// Naming the keys for the enum as the Component they correspond to rather than the route name itself
export enum RouteLocations {
  HOME = '/home',
  EXPERIMENTS = '/list',
  CLIENTS = '/clients',
  LIBRARY = '/library',
  // the grid route is a prefix - like /grid/command-center so this shouldn't be used bare
  GRID = '/grid',
  DATA_SOURCES = '/data-sources',
  ANALYSIS = '/analysis',
  HYPE = '/hype',
}
